import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import IconBadge from './icon-badge'

const HighRiskPermissionBadge = ({ count, displayCount = true }) => (
  <IconBadge
    icon={faExclamationCircle}
    iconColor="text-warning"
    tooltipText="High Risk Permission"
    count={displayCount ? count : undefined}
    text={displayCount ? undefined : 'High Risk'}
    className="fw-normal ms-2"
    data-testid="risk-badge"
  />
)

export default HighRiskPermissionBadge
